//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PendoIcon from '@/components/icon/pendo-icon.vue';
import { getContrastingColor, isValidHex, getColor } from '@/utils/color';

export default {
    name: 'PendoTag',
    components: {
        PendoIcon
    },
    props: {
        /**
         * type of tag
         * @values success, info, error, warning, filter, beta, sdk
         */
        type: {
            type: String,
            default: null,
            validator: (type) => ['success', 'info', 'error', 'warning', 'filter', 'beta', 'sdk'].includes(type)
        },
        /**
         * Hex value to use for tag color
         */
        color: {
            type: String,
            default: '#BABCC5',
            validator: (color) => isValidHex(color)
        },
        /**
         * Tag text
         */
        label: {
            type: String,
            default: null
        },
        /**
         * size of label
         * @values medium, small, mini
         */
        size: {
            type: String,
            default: 'medium',
            validator: (size) => ['mini', 'small', 'medium'].includes(size)
        },
        /**
         * whether Tag can be removed
         */
        closable: {
            type: Boolean,
            default: false
        },
        /**
         * places pendo-icon on left of label
         */
        prefixIcon: {
            type: [String, Object],
            default: null
        },
        /**
         * places pendo-icon on right of label
         */
        suffixIcon: {
            type: [String, Object],
            default: null
        },
        /**
         * round corners of tag
         */
        round: {
            type: Boolean,
            default: false
        },
        /**
         * applies subtle colors
         */
        subtle: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        formattedPrefix () {
            if (typeof this.prefixIcon === 'string') {
                return {
                    type: this.prefixIcon,
                    size: 14
                };
            }

            return this.prefixIcon;
        },
        formattedSuffix () {
            if (typeof this.suffixIcon === 'string') {
                return {
                    type: this.suffixIcon,
                    size: 14
                };
            }

            return this.suffixIcon;
        },
        styleObject () {
            if (this.type) {
                return {};
            }

            if (this.subtle) {
                const { hex: backgroundColor } = getColor({ hex: this.color, alpha: 0.15 });
                const subtleTextColor = this.color === '#BABCC5' ? '#6A6C75' : this.color;

                return {
                    backgroundColor,
                    borderColor: 'transparent',
                    color: subtleTextColor
                };
            }

            const textColor = getContrastingColor(this.color);

            return {
                backgroundColor: this.color,
                borderColor: this.color,
                color: textColor
            };
        },
        tagLabel () {
            if (this.type === 'beta') {
                return 'Beta';
            }

            return this.text || this.label;
        }
    },
    methods: {
        handleClose (event) {
            event.stopPropagation();
            /**
             * Emitted when user closes a tag
             *
             * @event close
             * @property {Event} $event - Dom Event
             */
            this.$emit('close', event);
        }
    }
};
